<section><hr class="my-6"><footer class="footer mt-6"><slot><p>Copyright  <a href="https://squarebell.com/" target="_blank">Square Bell Ltd</a> 
(2021&ndash;2023)</p></slot></footer></section>